export default __webpack_public_path__ + "static/media/loading.f9c5a4fc.svg";